import { Form, FormInstance, Input } from 'antd';
import { FormField, FormTextArea } from '../../../components/form/FormBasic';
import { FormFieldTypeEnum } from '../../../enums/FormFieldTypeEnum';
import { REGEX_ALL_ALLOWED_SAFE_FILTER } from '../../../constants/regex';

interface AddNewsLetterFormProps {
  form: FormInstance;
  handleCancel: () => void;
  getConfirmation: () => void;
  t: (key: string) => string;
}

const AddNewsLetterForm: React.FC<AddNewsLetterFormProps> = ({
  form,
  handleCancel,
  getConfirmation,
  t,
}) => {
  return (
    <>
      <Form layout="vertical" form={form} name="addNewsLetterForm" className="mt-2 w-full">
        <FormField
          name="title"
          label={t('title')}
          placeholder={t('titlePlaceholder')}
          disabled={false}
          type={FormFieldTypeEnum.INPUT}
          isRequired={true}
          allowLeadingTrailingSpaces={true}
          rules={[
            { required: true, message: t('titleFieldRequired') },
            {
              validator: (_, value) => {
                if (value && value.trim() === '') {
                  return Promise.reject(t('titleSpaceValidation'));
                }
                return Promise.resolve();
              },
            },
            {
                validator: (_, value) => {
                  if (!value) return Promise.resolve();
                  // Allow letters, numbers, space, punctuation and special characters
                  const regex = REGEX_ALL_ALLOWED_SAFE_FILTER;
                  return regex.test(value) ? Promise.resolve() : Promise.reject(t('invalidInput'));
                },
              },
            {
              validator: (_, value) => {
                if (!value || value.trim() === '') {
                  return Promise.resolve();
                }

                const trimmedLength = value.replace(/\s/g, '').length;
                if (trimmedLength < 3) {
                  return Promise.reject(t('titleMinValidation'));
                }
                return Promise.resolve();
              },
            },
            {
              validator: (_, value) => {
                if (!value || value.trim() === '') {
                  return Promise.resolve();
                }

                const trimmedLength = value.replace(/\s/g, '').length;
                if (trimmedLength > 100) {
                  return Promise.reject(t('titleMaxValidation'));
                }
                return Promise.resolve();
              },
            },
          ]}
        />
        <FormTextArea
          name="summary"
          label={t('summary')}
          rules={[
            { required: false },
            {
              validator: (_, value) => {
                if (value && value.trim() === '') {
                  return Promise.reject(t('summarySpaceValidation'));
                }
                return Promise.resolve();
              },
            },
            {
                validator: (_, value) => {
                  if (!value) return Promise.resolve();
                  // Allow letters, numbers, space, punctuation and special characters
                  const regex = REGEX_ALL_ALLOWED_SAFE_FILTER;
                  return regex.test(value) ? Promise.resolve() : Promise.reject(t('invalidInput'));
                },
              },
            {
              validator: (_, value) => {
                if (!value || value.trim() === '') {
                  return Promise.resolve();
                }

                const trimmedLength = value.replace(/\s/g, '').length;
                if (trimmedLength < 1) {
                  return Promise.reject(t('summaryMinValidation'));
                }
                return Promise.resolve();
              },
            },
            {
              validator: (_, value) => {
                if (!value || value.trim() === '') {
                  return Promise.resolve();
                }

                const trimmedLength = value.replace(/\s/g, '').length;
                if (trimmedLength > 200) {
                  return Promise.reject(t('summaryMaxValidation'));
                }
                return Promise.resolve();
              },
            },
          ]}
          placeholder={t('summaryFieldPlaceholder')}
          disabled={false}
          isRequired={false}
        />
      </Form>
    </>
  );
};

export default AddNewsLetterForm;
